<template>
    <div class="banner" @click="routeTopic">
        <a-tag class="tag" :color="topic.image.color" size="large">专题</a-tag>
        <span class="banner-title" :style="topic.image.titleCss"><em>{{ topic.title }}</em></span>
        <span class="banner-summary" :style="topic.image.summaryCss">作者： {{ topic.author }}</span>
        <span class="banner-content" v-if="topic.image.contentCss" :style="topic.image.contentCss">{{ summary }}</span>
        <img class="banner-img" :src="topic.image.img"/>
    </div>
</template>

<script>
    export default {
        name: "Banner",
        props: ['topic'],
        computed: {
            summary() {
                if (this.topic.summary.length > 100) {
                    return this.topic.summary.substring(0, 100).concat("...");
                }
                return this.topic.summary;
            }
        },
        methods: {
            routeTopic() {
                window.open('/topic/'.concat(this.topic.topicId), '_blank');
            }
        }
    }
</script>
<style scoped>
    .banner {
        position: relative;
        width: 1187px;
        height: 243px;
        cursor: pointer;
    }
    .tag {
        position: absolute;
        top: 0;
        right: 0;
        margin: 1px;
    }
    .banner-title {
        position:absolute;
        line-height: 1.5;
    }
    .banner-img {
        height: 100%;
        width: 100%;
    }
    .banner-summary {
        position:absolute;
        line-height: 1.5;
    }
    .banner-content {
        position: absolute;
        line-height: 1.5;
        text-align: left;
    }

</style>